
import { activeList, g_listOrigin, lang } from "../core/variables-global.js";
import { filtresLabels } from "../core/l10n.js";

function initSetupFiltres() {
  let currentDeviceType = null;
  const targetContainer = document.querySelector(".js-section-filtres-avances");


  const isMobileDevice = () => {
    return window.innerWidth < 640 || window.matchMedia("(max-width: 640px)").matches;
  };

  const getDeviceType = () => {
    return isMobileDevice() ? "mobile" : "desktop";
  };

  const generateMobileTemplate = () => {
    return `<div class="filtre-mobile js-filtre-mobile">
          <button class="hq-bouton-secondaire js-hq-modale-btn" data-modale-id="modale-1002" aria-haspopup="dialog">
              <img class="hq-icone-large hq-mr-8"
                  src="/themes/mieux-consommer/recherche-themopompes-efficaces/img/filtres.svg"
                  alt="">
              <span class="js-bouton-texte">${filtresLabels[lang].optionRecherche}</span>
          </button>
          <p class="criterias criterias-2 js-criterias-2" aria-hidden="true"></p>
          <div data-modale-id="modale-1002" aria-modal="true" role="dialog" aria-labelledby="title-id-1"
              class="hq-modal js-hq-modale hq-modal-longue" aria-hidden="true">
              <div class="hq-modal-content">
                  <div class="hq-modal-header">
                      <img class="hq-icone-large"
                          src="/themes/mieux-consommer/recherche-themopompes-efficaces/img/filtres.svg"
                          alt="Texte compréhensible hors contexte">
                      <div class="title-block">
                          <h3 id="title-id-1" class="hq-modal-titre">${filtresLabels[lang].optionRecherche}</h3>
                          <p class="criterias js-criterias-1">(0 critères actifs)</p>
                      </div>
                      <div class="block-btn-close">
                          <button class="hq-bouton-texte hq-modal-close-btn hq-bouton-fermer js-hq-close-btn"
                              aria-label="${filtresLabels[lang].fermer}" data-last-word="false">
                              <span class="js-bouton-icon">
                                  <svg class="hq-icone-large" aria-hidden="true">
                                      <use href="/@hydroquebec/assets/dist/icones/sprite.svg#hq-icone-fermer-2"></use>
                                  </svg>
                              </span>
                          </button>
                      </div>
                  </div>
                  <div class="hq-modal-text">
                      ${generateFormContent()}
                  </div>
              </div>
          </div>
      </div>`;
  };

  const generateDesktopTemplate = () => {
    return `<div class="hq-accordeon filtre-desktop js-filtre-desktop">
        <div class="accordeon-tiroir js-accordeons">
            <h3>
                <button type="button" aria-expanded="false" aria-controls="accordeon-777-tiroir-0"
                    id="accordeon-777-bouton-0" class="titre button-display-filters js-button"
                    data-accordeon="accordeon-777,0" aria-disabled="true" disabled="true">
                    <span class="label-accordeon">${filtresLabels[lang].rechercheFiltres}</span>
                </button>
            </h3>
            <div class="accordeon-inner js-accordeon-inner" id="accordeon-777-tiroir-0" role="region"
                aria-labelledby="accordeon-777-bouton-0" hidden="">
                ${generateFormContent()}
            </div>
        </div>
    </div>`;
  };

  const generateFormContent = () => {
    return `<form class="recherche-avancee-form">
    <div class="hq-grid hq-grid-cols-4 sm:hq-grid-cols-12">
      <div class="hq-col-span-4 sm:hq-col-span-12 md:hq-col-span-12">
          <div class="wall-of-errors js-wall-of-errors">
            <section class="hq-bandeau-message-alerte js-wall" aria-labelledby="message-global-titre-1">
              <svg class="hq-icone-large" aria-label="alerte">
                <use href="/@hydroquebec/assets/dist/icones/sprite.svg#hq-icone-danger-plein"></use>
              </svg>
              <h4 id="message-global-titre-1" class="js-wall-title"></h4>
              <div class="js-dummy-cnt">
                <ul class="hq-liste js-wall-list"></ul>
              </div>
            </section>
          </div>
        </div>
      <div class="hq-col-span-4 sm:hq-col-span-6 md:hq-col-span-8">
        <fieldset class="selection-marques js-selection-marques">
          <legend class="legend">${filtresLabels[lang].marque}</legend>
          <p class="texte-aide">${filtresLabels[lang].choixMarques}</p>
          <div class="search-container">
            <div class="search-box">
              <input type="text" class="input js-input js-input-marque"
                aria-autocomplete="list" aria-controls="options" autocomplete="off" role="combobox"
                aria-expanded="false">
                <div class="visuallyhidden js-announce" aria-live="polite"></div>
            </div>
            <ul class="options js-options" role="listbox" id="options"></ul>
          </div>
          <div class="status-message js-status-message"></div>
            <div class="selected-items js-selected-items" aria-live="polite"></div>
        </fieldset>
      </div>
      <div class="hq-col-span-4 sm:hq-col-span-6 md:hq-col-span-4 js-thermopompe-he container-thermopompe-he">
          <fieldset class="hq-form-checkboxes">
              <legend class="legend">${ (g_listOrigin === "es") ? filtresLabels[lang].thermoHauteEfficacite_es : filtresLabels[lang].thermoHauteEfficacite}</legend>
              <div class="checkboxes-wrapper">
                  <div class="hq-checkbox">
                      <div class="label-input-wrapper">
                          <input class="input js-input-avance js-checkbox-input js-checkbox-thermopompe-he"
                              type="checkbox" id="tthe-display" name="display-checkbox" value="false">
                          <label class="label" for="tthe-display">
                            ${ (g_listOrigin === "es") ? filtresLabels[lang].afficherThermoHauteEfficacite_es : filtresLabels[lang].afficherThermoHauteEfficacite}
                          </label>
                      </div>
                  </div>
              </div>
            </fieldset>
        </div>
      </div>

    <fieldset class="recherche-modeles">
        <div class="modele-item">
            <label class="label" for="modele-ext">${filtresLabels[lang].modeleExterieur}</label>
            <input type="text" class="input modele-ext js-modele_externe" name="modele_externe">
        </div>
        <div class="modele-item">
            <label class="label" for="modele-int">${filtresLabels[lang].modeleInterieur}</label>
            <input type="text" class="input modele-int js-modele_interne" name="modele_interne">
        </div>
        <div class="modele-item">
            <label class="label" for="modele-fournaise">${filtresLabels[lang].fournaise}</label>
            <input type="text" class="input modele-fournaise js-fournaise" name="fournaise" id="modele-fournaise">
        </div>
    </fieldset>

    <fieldset class="puissance-aide-financiere">
        <div class="puissance-container">
            <label class="label" id="puissance-nominale-label">${ (activeList.name === "menages-revenu-modeste") ? filtresLabels[lang].puissanceNominale_custom : filtresLabels[lang].puissanceNominale_custom}</label>
            <div class="range-container" role="group" aria-labelledby="puissance-nominale-label" data-validating="minmax">
                <div class="range-item">
                    <span class="texte-descriptif" id="puissance-min-text">Minimum</span>
                    <div class="input-unit js-input-unit">
                        <input type="number" class="input js-input-avance js-puissance_nominale_min"
                            name="puissance_nominale_min" id="puissance-nominale-min"
                            aria-labelledby="puissance-nominale-label puissance-min-text btu-h-min-1" min="0" max="999999999" step="1">
                        <span class="unit btu" id="btu-h-min-1">BTU/h</span>
                    </div>
                </div>
                <div class="range-item">
                    <span class="texte-descriptif" id="puissance-max-text">Maximum</span>
                    <div class="input-unit js-input-unit">
                        <input type="number" class="input js-input-avance js-puissance_nominale_max"
                            name="puissance_nominale_max" id="puissance-nominale-max"
                            aria-labelledby="puissance-nominale-label puissance-max-text btu-h-max-1" min="0" max="999999999" step="1">
                        <span class="unit btu" id="btu-h-max-1">BTU/h</span>
                    </div>
                </div>
            </div>
            <div class="status-message js-status-message"></div>
            <div class="hq-form-checkboxes">
                <div class="checkboxes-wrapper checkboxes-wrapper--seule">
                    <div class="hq-checkbox">
                        <div class="label-input-wrapper">
                            <input class="input js-input-avance js-checkbox_puissance_nominale" type="checkbox"
                                id="puissance-nominale-display" name="display_checkbox_pn" value="false">
                            <label class="label" for="puissance-nominale-display">${ (activeList.name === "menages-revenu-modeste") ? filtresLabels[lang].afficherPuissanceNominale_custom : filtresLabels[lang].afficherPuissanceNominale}</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="puissance-container js-puissance-moins-8-bloc">
            <label class="label" id="puissance-moins8-label">${filtresLabels[lang].puissanceMoins8}</label>
            <div class="range-container" role="group" aria-labelledby="puissance-moins8-label" data-validating="minmax">
              <div class="range-item">
                <span class="texte-descriptif" id="moins8-min-text">Minimum</span>
                <div class="input-unit js-input-unit">
                  <input type="number" class="input js-input-avance js-puissance_moins_8_min"
                    name="puissance_moins8_min" id="puissance-moins8-min"
                    aria-labelledby="puissance-moins8-label moins8-min-text btu-h-min-2" min="0" max="999999999" step="1">
                  <span class="unit btu" id="btu-h-min-2">BTU/h</span>
                </div>
            </div>
            <div class="range-item">
              <span class="texte-descriptif" id="moins8-max-text">Maximum</span>
              <div class="input-unit js-input-unit">
                <input type="number" class="input js-input-avance js-puissance_moins_8_max"
                  name="puissance_moins8_max" id="puissance-moins8-max"
                  aria-labelledby="puissance-moins8-label moins8-max-text btu-h-max-2" min="0" max="999999999" step="1">
                <span class="unit btu" id="btu-h-max-2">BTU/h</span>
              </div>
            </div>
          </div>
          <div class="status-message js-status-message"></div>
          <div class="hq-form-checkboxes">
            <div class="checkboxes-wrapper checkboxes-wrapper--seule">
              <div class="hq-checkbox">
                <div class="label-input-wrapper">
                  <input class="input js-input-avance js-checkbox_puissance_moins_8" type="checkbox"
                    id="puissance-moins8-display" name="display-checkbox_moins" value="false">
                  <label class="label" for="puissance-moins8-display">${filtresLabels[lang].afficherPuissanceMoins8}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="puissance-container js-aide-financiere-bloc">
          <label class="label" id="aide-financiere-label">${filtresLabels[lang].aideFinanciere}</label>
          <div class="range-container" role="group" aria-labelledby="aide-financiere-label" data-validating="minmax">
            <div class="range-item">
              <span class="texte-descriptif" id="financiere-min-text">Minimum</span>
              <div class="input-unit js-input-unit">
              <input type="number" class="input js-input-avance js-aide_financiere_min"
                name="aide_financiere_min" id="aide-financiere-min"
                aria-labelledby="aide-financiere-label financiere-min-text dollar-1" min="0" max="999999999" step="1">
                <span class="unit dollar" id="dollar-1">$</span>
              </div>
            </div>
            <div class="range-item">
              <span class="texte-descriptif" id="financiere-max-text">Maximum</span>
              <div class="input-unit js-input-unit">
                <input type="number" class="input js-input-avance js-aide_financiere_max"
                  name="aide_financiere_max" id="aide-financiere-max"
                  aria-labelledby="aide-financiere-label financiere-max-text dollar-2" min="0" max="999999999" step="1">
                <span class="unit dollar" id="dollar-2">$</span>
              </div>
            </div>
          </div>
          <div class="status-message js-status-message"></div>
        </div>

      </fieldset>
      <fieldset>
        <div class="hq-form-checkboxes">
          <div class="checkboxes-wrapper checkboxes-wrapper--seule">
            <div class="hq-checkbox">
              <div class="label-input-wrapper">
                <input class="input js-input-avance js-checkbox_admissible_bonification" type="checkbox"
                    id="admissible-bonification-display" name="display-checkbox_admissible_bonification" value="false">
                <label class="label" for="admissible-bonification-display">${filtresLabels[lang].admissible_bonification}</label>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <div class="button-section">
          <button type="button" class="js-button-filtres hq-bouton-primaire">${filtresLabels[lang].btnAppliquer}</button>
          <button type="reset" class="js-button-reset hq-bouton-secondaire">${filtresLabels[lang].btnReset}</button>
      </div>
  </form>`;
  };

  const removeExistingTemplate = () => {
    const existingMobile = document.querySelector('.js-filtre-mobile');
    const existingDesktop = document.querySelector('.js-filtre-desktop');

    if (existingMobile) {
      existingMobile.remove();
    }
    if (existingDesktop) {
      existingDesktop.remove();
    }
  };

  const renderTemplate = () => {
    const deviceType = getDeviceType();

    // Ne rien faire si le type d'appareil n'a pas changé
    if (currentDeviceType === deviceType) {
      return;
    }

    // Supprimer le template existant
    removeExistingTemplate();

    // Générer et insérer le nouveau template
    console.log("Initializing setupFiltres...", activeList.name);
    const template = deviceType === "mobile" ? generateMobileTemplate() : generateDesktopTemplate();
    targetContainer.insertAdjacentHTML("afterend", template);

    // Mettre à jour le type d'appareil actuel
    currentDeviceType = deviceType;

    // Réinitialiser les sélecteurs et composants
    window.tableauResultats.setSelectors();
    window.initMarquesSelector.resetSelectedMarques();
    window.initMarquesSelector.init();

    // If LisT is "menages-revenu-modeste", hide the "puissance moins 8" filter by default and hide aide financiere filter
    if (activeList.name === "menages-revenu-modeste") {
      const puissanceMoins8Bloc = document.querySelector(".js-puissance-moins-8-bloc");
      if (puissanceMoins8Bloc) {
        puissanceMoins8Bloc.style.display = "none";
        puissanceMoins8Bloc.setAttribute("aria-hidden", "true");
      }
    }
    if (activeList.name === "menages-revenu-modeste" || activeList.name === "office-habitation") {
      const aideFinanciereBloc = document.querySelector(".js-aide-financiere-bloc");
      if (aideFinanciereBloc) {
        aideFinanciereBloc.style.display = "none";
        aideFinanciereBloc.setAttribute("aria-hidden", "true");
      }
    }


    if(deviceType === "desktop"){
      const accordeonButton = document.querySelector(".js-filtre-desktop .js-button");
      const accordeons = document.querySelectorAll(".js-filtre-desktop .js-accordeons");
      accordeonButton.removeAttribute("disabled");
      accordeonButton.removeAttribute("aria-disabled");
      document.body.style.overflow = "auto";

      if(accordeons) {
        accordeonModule.init(accordeons);
      }

      return
    }

    if(deviceType === "mobile") {
      let btnModale = document.querySelector(".js-hq-modale-btn");
      if (btnModale) {
        modaleModule.init(btnModale);
        window.initRechercheMobile.setupMobileFilterButtons();
      }
      return
    }


  };

  // Observer pour détecter les changements de taille de viewport
  const resizeObserver = new ResizeObserver(() => {
    renderTemplate();
  });

  // Initialisation
  if (targetContainer) {
    renderTemplate();
    resizeObserver.observe(document.body);
  }

  // Retourner une fonction de nettoyage pour pouvoir déconnecter l'observer si nécessaire
  return () => {
    resizeObserver.disconnect();
  };
}

window.initSetupFiltres = initSetupFiltres;
export default initSetupFiltres;
